// extracted by mini-css-extract-plugin
export default {"container":"image-component_container__ACjHX","truncate-table":"image-component_truncate-table__SByMB","table-text-faded":"image-component_table-text-faded__ShjrF","placeholder":"image-component_placeholder__av-Yr","placeholder-text":"image-component_placeholder-text__y87N-","icon":"image-component_icon__zwOzj","imageContainer":"image-component_imageContainer__DWVk-"};
    if(module.hot) {
      // 1792500641680
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  